import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { AppSettings } from '../app.settings';
import { WindowRef } from './util/window.ref';
import { debug } from 'util';

@Injectable()
export class AuthenticationService {
    redirectUrl: string;
    nativeWindow: any;

    constructor(
        private http: Http,
        private router: Router,
        private winRef: WindowRef
    ) {
        this.nativeWindow = winRef.getNativeWindow();
    }

    login(username: string, password: string) {
        //
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Cache-Control', 'no-cache');
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('Access-Control-Allow-Methods', 'POST');
        let options = new RequestOptions({ headers: headers });

        return this.http.post(AppSettings.API_ENDPOINT + '/token/login', JSON.stringify({ "userName": username, "password": password }), options)
            .map((response: any) => {
                /*
                // login successful if there's a jwt token in the response
                let user = response.json();
                if (user && user.authToken) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(response.json()));
                }
                */
            
                localStorage.setItem('currentUser', response._body);
                //localStorage.setItem('currentUser', JSON.stringify(response.json()[0]));
            });
    }

    getToken(procedureTypeId: number, username: string, password: string) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Cache-Control', 'no-cache');
        headers.append('X-Requested-With', 'XMLHttpRequest');
        headers.append('Access-Control-Allow-Methods', 'POST');
        let options = new RequestOptions({ headers: headers });

        return this.http.post(AppSettings.API_ENDPOINT + '/token/external/' + procedureTypeId, JSON.stringify({ "email": username, "password": password }), options).map((response: Response) => response.json());
    }

    logout() {
        localStorage.removeItem('currentUser');
        this.router.navigate(['/pages/login']);
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/authentication.service.ts